<template>
  <FreeBottomSheet :name="name">
    <template #header>
      <FreeHeader class="p-4">
        <template #default>
          <h2 class="text-text-neutral-primary text-base font-medium">
            {{ t('main.searchFormCalendar.airline') }}
          </h2>
        </template>
        <template #rightAction>
          <button
            type="button"
            class="text-text-neutral-secondary bg-situational-lightgrey rounded-2xl px-3 py-1.5 disabled:opacity-40"
            :disabled="!selectedAirline"
            @click="onResetFilter"
          >
            {{ t('general.clear') }}
          </button>
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="mb-4 flex flex-col gap-3 px-4">
        <button
          v-for="(airline, idx) in airlines"
          :key="idx"
          class="bg-background-neutral-secondary flex w-full items-center justify-between rounded-2xl p-3"
          :class="
            selectedAirline?.iata === airline.iata &&
            'border-background-positive-primary border'
          "
          type="button"
          @click="onAirlineListClick(airline, idx)"
        >
          <div class="flex items-center gap-4">
            <div
              class="bg-static-white border-situational-lightgrey flex h-10 w-10 items-center justify-center rounded-2xl border"
            >
              <img
                class="h-6 w-6"
                :src="staticUrls.airlineLogoUrl(airline?.iata ?? '')"
                alt=""
              />
            </div>
            <p class="text-text-neutral-primary text-base font-semibold">
              {{ airline.name_ru }}
            </p>
          </div>
          <img
            v-if="selectedAirline?.iata === airline.iata"
            class="h-6 w-6"
            src="@/assets/images/green-check.svg"
            alt=""
          />
        </button>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { FreeBottomSheet, FreeHeader } from 'freedom-shared';
  import { useI18n } from 'vue-i18n';
  import type { Dict } from '@aviata/platform-types';

  import { staticUrls } from '@/shared/config';

  defineProps<{
    name: string;
    airlines: Dict.Airlines.Airline[];
    selectedAirline: Dict.Airlines.Airline | null;
    isDirectFlights: boolean;
  }>();

  const emit = defineEmits<{
    onAirlineClick: [{ airline: Dict.Airlines.Airline; idx: number }];
    onResetFilter: [];
  }>();

  const { t } = useI18n();

  const onResetFilter = () => {
    emit('onResetFilter');
  };

  const onAirlineListClick = (airline: Dict.Airlines.Airline, idx: number) => {
    emit('onAirlineClick', { airline, idx });
  };
</script>
